import React from "react";
import { Redirect } from "react-router-dom";
import {
  Container,
  Button,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  FormLabel,
  Form,
  Tab,
  Nav,
  Accordion,
  Card,
  Modal,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import OutsideClickHandler from "react-outside-click-handler";
import filterFactory from "react-bootstrap-table2-filter";
import { FiChevronDown } from "react-icons/fi";
import $ from "jquery";
import { HidSelector } from "../../Common/Components/HidSelector";
import { SingleSearchDropdownList } from "../../Common/Components/SingleSearchDropdownList";
import { ReactPageLoader } from "../../Common/Components/ReactPageLoader";
import { TableCustomSearch } from "../../Common/Components/TableCustomSearch";
import { Facility } from "../../Common/Services/Facility";
import { EntityManagementService } from "../../Common/Services/EntityManagementService";
import "./Location.scss";
import "./facilities.scss";
import _ from "lodash";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { IGetAssetsListRequest } from "../../Common/Contracts/IFacilities";
import { FacilityMaintenance } from "../../Common/Services/FacilityMaintenance";
import {
  IFacilityMaintenanceListRequest,
  IFacilityMaintenanceScheduleResponse,
} from "../../Common/Contracts/IMaintenanceSchedule";
import { FacilityPreventativeMaintenance } from "../../Common/Services/FacilityPreventativeMaintenance";
import {
  IFacilityPreventativeMaintenanceRequest,
  IFacilityPreventativeMaintenanceResponse,
} from "../../Common/Contracts/IPreventativeMaintenance";
import moment from "moment";
import "./PreventativeMaintenance.scss";
import { PreventativeMaintenanceSlideOut } from "./PreventativeMaintenanceSlideOut";
import { Hotel } from "../../Common/Services/Hotel";
import { IHotelResponseDto } from "../../Common/Contracts/IHotel";
import { resolve, reject } from "q";
import { Utils } from "../../Common/Utilis";
import TableSearch from "../../Common/Components/TableSearch";
import "react-circular-progressbar/dist/styles.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

import blankImg from "../../Common/Assets/Images/preventative-maintenance.png"
import { AddMaintenanceSchedule } from "./addMaintenanceSchedule";
import { FALSE } from "sass";
import { MaintenanceSchudleSlieOut } from "./MaintenanceSchudleSlieOut";
import { MaintenanceScheduleBulkUpload } from "./MaintenanceScheduleBulkUpload";

const statusList = [
  { id: null, name: "All" },
  { id: "In Progress", name: "In Progress" },
  { id: "Overdue", name: "Overdue" },
  { id: "Upcoming", name: "Upcoming" },
];

export class PreventativeMaintenance extends React.Component<any, any> {
  private child: any;
  private childHID: any;
  private departmentSearch: any;
  private empTypeSearch: any;
  private tableTypeSearch: any;
  private scheduleUserViewRef: any;
  private manageTableSearchnew: any;
  constructor(props: any) {
    super(props);
    this.scheduleUserViewRef = React.createRef();
    this.child = React.createRef();
    this.childHID = React.createRef();
    this.departmentSearch = React.createRef();
    this.empTypeSearch = React.createRef();
    this.tableTypeSearch = React.createRef();
    this.manageTableSearchnew = React.createRef();
    this.state = {
      pageLoader: false,
      isDataLoading: false,
      showAddAssetModal: false,
      hidValue: "Select",
      hotelName: "Select",
      tableData: [],
      initialTableData: [],
      frequencies: [],
      priorities: [],
      createEditPermission: false,
      searchText: "",
      status: "",
      frequency: "",
      priority: "",
      sortingOrder: "asc",
      sortingField: "name",
      sortingOrder3: "asc",
      sortingField3: "name",
      sortingOrder1: "asc",
      sortingField1: "name",
      sortingOrder2: "asc",
      sortingField2: "name",
      activeStatus: "Active",
      showSlideout: false,
      parentRowData: [],
      manageParentRowData: [],
      commentUserType: "PreventiveCommentType",
      isPMCycleType: "",
      lastcycleId: "",
      lastroomId: "",
      ParmaworkOrdrValue: "",
      activeTab: "Active",
      selectedRows: [],
      manageTableData: [],
      manageTableDataFilter: [],
      manageCreateEditPermission: false,
      activeKeys: ["0", "1", "2"],
      isNewPmProject: false,
      assetTypes: [],
      isStartEarly:false,
      rowCycleId:"",
      rowstartDate:"",
      reason: "",
      errors:false,
      isSlideOut: false,
      bulkImportModal: false,
    };
  }

  componentDidMount() {
    let hotelId = this.getURLParamsValues()?.hotelId;
    let status = this.getURLParamsValues()?.status;
    let source = this.getURLParamsValues()?.source;

    //debugger;
    let storage = JSON.parse(localStorage.getItem("hotelSelected")!);
    let storagehotelid = storage === null ? -1 : (storage.hotelID as any);
    let deepParam = localStorage.getItem("deepParam");
    let param = "";
    if (source == "overview") {
      hotelId = atob(hotelId);
      this.setState({ status: status == "Open" ? "In Progress" : "Overdue", isRefresh: true }, () => {
        this.loadHotelsDetails(hotelId);
        this.setState({ isRefresh: false })
      })
    }
    else if (deepParam !== "") {

      try {
        param = atob(String(window.location.href.split("?")[1]));

        let paramValue = param.split('&')[0];
        let paramValue1 = param.split('&')[1];
        let paramValue2 = param.split('&')[2];
        let hid = paramValue.split('=')[1];
        let cycleId = paramValue1.split('=')[1];
        let roomId = paramValue2.split('=')[1];
        //  this.GetWorkOrdeStatus(hid,workOrdrid);
        this.loadHotelDetails(hid, cycleId, roomId, "redirectLink");

      } catch {
        this.setState({ isLoader: false, mobileLoader: false });
        window.location.href = "/unauthorize-access";
      }
    }
    this.getAssetTypes();
    this.getPriority();
    this.getFrequency();

    this.CheckAddEditPermission();
    this.ManageCheckAddEditPermission();
    if (this.state.activeTab == "Manage") {
      this.getAllMaintenanceSchedule();
    }
  }
  getAssetTypes = () => {
    Facility.GetDistinctAssetTypeList().then((assetTypes: any) => {
      if (assetTypes?.length > 0) {
        assetTypes = assetTypes.map((x) => {
          return { id: x?.assetTypeId, name: x?.assetTypeName };
        });
      }
      this.setState({ assetTypes });
    });
  };
  handleAccordionToggle = (eventKey) => {
    this.setState((prevState) => {
      const { activeKeys } = prevState;
      return {
        activeKeys: activeKeys.includes(eventKey)
          ? activeKeys.filter((key) => key !== eventKey)
          : [...activeKeys, eventKey],
      };
    });
  };

  loadHotelsDetails(hid) {
    Hotel.getUserHotelAccess("Facility Maintenance")
      .then(async (result: IHotelResponseDto[] | null) => {
        if (result != null) {

          const hotelDetail: any = result.find(
            (r) => +r?.hotelID === +hid);

          localStorage.setItem("hotelSelected", JSON.stringify(hotelDetail));
          sessionStorage.setItem(
            "hotelSelected",
            JSON.stringify(hotelDetail)
          );

          this.childHID?.current?.updateChildState(hotelDetail)
          this.setState({ hidValue: hotelDetail.hotelID }, () => {
            this.selectHotelDropDown(hotelDetail);
          });
          //  this.selectHotelDropDown(hotelDetail);
        }
      })
      .catch((error) => {
        reject();
      });
  }


  getParamValueByParamName(paramName: string): any {
    const valuesArray = decodeURIComponent(this.props.history.location.search)?.replace('?', '')?.split('&');
    const item = valuesArray?.find(r => r?.includes(paramName));
    return item?.split('=')[1];
  }
  getURLParamsValues = (): any => {
    const paramObject: any = {
      hotelId: this.getParamValueByParamName("hotelId"),
      status: this.getParamValueByParamName("status"),
      source: this.getParamValueByParamName("source"),
    }
    return paramObject;
  }

  CheckAddEditPermission = () => {
    Facility.FacilityMaintenanceCheckEditStatusPermission().then((res) => {
      this.setState({ createEditPermission: res?.result });
    });
  };
  ManageCheckAddEditPermission = () => {
    Facility.FacilityMaintenanceCheckAddEditPermission().then((res) => {
      this.setState({ manageCreateEditPermission: res?.result });
    });
  };

  loadHotelDetails(hid: any, cycleId: any, roomId: any, type: any) {
    // debugger;
    Hotel
      .getUserHotelAccess("Facility Maintenance")
      .then(async (result: IHotelResponseDto[] | null) => {
        //    debugger;
        if (result != null) {
          this.setState({ hidList: result });
          if (hid) {
            const hotelDetail = result.find(
              (r) => +r?.hotelID === +hid
            );
            localStorage.setItem("hotelSelected", JSON.stringify(hotelDetail));
            sessionStorage.setItem(
              "hotelSelected",
              JSON.stringify(hotelDetail)
            );
            this.setState({
              lastcycleId: cycleId, lastroomId: roomId,
              isPMCycleType: "ParamcycleIdType", ParmaworkOrdrValue: "Parmavalue"
            });


            // this.selectHotelDropDown(hotelDetail,"ParmaworkOrdridType",workOrdrid,type);
          }

        }
        //  resolve();
      })
      .catch((error) => {
        //  reject();
      });
  }

  selectHotelDropDown = (hotelDetails: any) => {
    this.setState({ pageLoader: true, searchText: "" });

    this.setState(
      {
        hotelName: hotelDetails.lettercode,
        hidValue: hotelDetails.hotelID,
        activeTab: "Active",
        sortingOrder3: "asc",
        sortingField3: "name",
        activeKeys: ["0", "1", "2"] 
      },
      () => {
        this.getAllPreventativeMaintenance();
        if (this.state.activeTab == "Manage") {
          this.getAllMaintenanceSchedule();
        }
      }
    );
    if (this.manageTableSearchnew.current !== null)
    {
    this.manageTableSearchnew.current.CleanSearch();
    }
  };

  getAllPreventativeMaintenance = () => {
    const { searchText, status, frequency, priority, hidValue, activeStatus } =
      this.state;
    const request: IFacilityPreventativeMaintenanceRequest = {
      query: "",
      status: status == "Status" ? "" : status,
      frequency,
      priority,
      MaintenanceStatus: activeStatus == "Inactive" ? "" : activeStatus,
      Hid: hidValue,
    };

    this.setState({ isDataLoading: true });

    FacilityPreventativeMaintenance.GetAllPreventativeMaintenance(request)
      .then((tableData: IFacilityPreventativeMaintenanceResponse[] | null) => {
        let _tableData = _.orderBy(tableData, ["name"], ["asc", "asc"]);
        _tableData = _tableData.map((x) => ({
          ...x,
          // noOfLocations:
          //   x.status.toLowerCase() == "upcoming" ? "" : x.noOfLocations,
        }));
        this.setState({
          isDataLoading: false,
          tableData: _.orderBy(
            _tableData,
            [item => item[this.state.sortingField3]?.toLowerCase() || ''],
            ["asc", "asc"]
          ),
          initialTableData: _.orderBy(
            _tableData,
            [item => item[this.state.sortingField3]?.toLowerCase() || ''],
            ["asc", "asc"]
          ),
        });
        // debugger;
        if (this.state.isPMCycleType == "ParamcycleIdType") {
          this.handleShowSlideout("", "row", "", "ParamcycleIdType", Number(this.state.lastcycleId));
        }

      })
      .catch((err) => {
        this.setState({ isDataLoading: false });
      });
  };

  handleOnCancel = () => {
    this.setState({isStartEarly:false});
  }

  handleStartEarly=()=>{
    
    if (this.state.reason === "") {
      this.setState({ errors: true });
      Utils.toastError(
        "Please enter reason for early start."
      );
    } else {

    let id=this.state.rowCycleId;
    let earlyReason=this.state.reason;
   FacilityPreventativeMaintenance.StartEarly({ CycleId: id,reason:earlyReason })
      .then((result) => {
        if (result.success) {
          this.setState({isStartEarly:false,errors:false,reason:""});
          toast.success(result?.result, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        } else {
          Utils.toastError(result?.result, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
        this.getAllPreventativeMaintenance();
      })
      .catch((err) => {
        Utils.toastError(`Server Error, ${err}`, {});
      });
    }
  }

  startEarly = (id,startDate:any) => {

    this.setState({rowCycleId:id},()=>{
    this.setState({isStartEarly:true,rowstartDate:startDate,reason:""});
    })
   
    
  };

  getFrequency = () => {
    FacilityMaintenance.GetFrequency().then((frequencies: any[] | null) => {
      let _frequencies = _.cloneDeep(frequencies);
      if (_frequencies?.length > 0) {
        _frequencies = _frequencies.map((item) => {
          return { id: item, name: item };
        });
      }
      this.setState({
        frequencies: [{ id: "", name: "All" }, ..._frequencies],
      });
    });
  };

  getPriority = () => {
    FacilityMaintenance.GetPriority().then((priorities: any[] | null) => {
      let _priorities = _.cloneDeep(priorities);
      if (_priorities?.length > 0) {
        _priorities = _priorities.map((item) => {
          return { id: item, name: item };
        });
      }
      this.setState({ priorities: [{ id: "", name: "All" }, ..._priorities] });
    });
  };

  onSearchChange = (searchText: string) => {
    this.setState({ searchText: searchText?.toString()?.trimStart() }, () => {
      // if (searchText?.length > 1 || !searchText) {
      // this.getAllPreventativeMaintenance();
      // var debounce = _.debounce(this.getAllPreventativeMaintenance, 1000);
      // debounce();
      // }
    });
    const filteredItems = this.state.initialTableData.filter((item) =>
      item.name.toLowerCase().includes(searchText?.toString()?.trim()?.toLowerCase()))
    this.setState({ tableData: filteredItems, activeKeys: ["0", "1", "2"] });
    this.setState({
    sortingOrder3: "asc",
    sortingField3: "name",
    sortingOrder1: "asc",
    sortingField1: "name",
    sortingOrder2: "asc",
    sortingField2: "name"})
  };

  onDDlFiltersChange = (controlID: any, id: any) => {
    let { frequency, status, priority } = this.state;
    switch (controlID) {
      case "ddlFrequency":
        frequency = id || "";
        break;
      case "ddlStatus":
        status = id || "";
        break;
      case "ddlPriority":
        priority = id || "";
        break;
      default:
        break;
    }

    this.setState({ frequency, status, priority }, () => {
      this.getAllPreventativeMaintenance();
    });
  };

  handleSortByColumn = (field) => {
    this.setState(
      {
        sortingField: field,
        sortingOrder: this.state.sortingOrder === "asc" ? "desc" : "asc",
      },
      () => {
        if (this.state.activeTab == "Active") {
          this.sortTableData(this.state.tableData, this.state.sortingField,1);
        } else if (this.state.activeTab == "Manage") {
          this.sortTableData(this.state.manageTableData, this.state.sortingField);
        }
      }
    );
  };
  handleSortByColumnActive = (field) => {
    this.setState(
      {
        sortingField3: field,
        sortingOrder3: this.state.sortingOrder3 === "asc" ? "desc" : "asc",
      },
      () => {
        if (this.state.activeTab == "Active") {
          this.sortTableData(this.state.tableData, this.state.sortingField3,1);
        } else if (this.state.activeTab == "Manage") {
          this.sortTableData(this.state.manageTableData, this.state.sortingField);
        }
      }
    );
  };
  handleSortByColumnUpcoming = (field) => {
    this.setState(
      {
        sortingField1: field,
        sortingOrder1: this.state.sortingOrder1 === "asc" ? "desc" : "asc",
      },
      () => {
        if (this.state.activeTab == "Active") {
          this.sortTableData(this.state.tableData, this.state.sortingField1,2);
        } else if (this.state.activeTab == "Manage") {
          this.sortTableData(this.state.manageTableData, this.state.sortingField);
        }
      }
    );
  };
  handleSortByColumnHistory = (field) => {
    this.setState(
      {
        sortingField2: field,
        sortingOrder2: this.state.sortingOrder2 === "asc" ? "desc" : "asc",
      },
      () => {
        if (this.state.activeTab == "Active") {
          this.sortTableData(this.state.tableData, this.state.sortingField2,3);
        } else if (this.state.activeTab == "Manage") {
          this.sortTableData(this.state.manageTableData, this.state.sortingField);
        }
      }
    );
  };

  sortTableData = (data, sortingField,value = 0) => {
    let sortedData:any[] = [];
    if (value == 1) {
      const upcomingData = data.filter(item => item.status === "In Progress" || item.status === 'Overdue');
      const otherData = data.filter(item => item.status !== "In Progress" && item.status !== 'Overdue');
      const sortedUpcoming = [...upcomingData].sort((a, b) => {
        const aValue = a[sortingField];
        const bValue = b[sortingField];
        if (!isNaN(aValue) && !isNaN(bValue)) {
          return this.state.sortingOrder3 === "asc"
            ? Number(aValue) - Number(bValue)
            : Number(bValue) - Number(aValue);
        }
        const aStr = aValue?.toString().toLowerCase() || '';
        const bStr = bValue?.toString().toLowerCase() || '';
  
        if (aStr < bStr) return this.state.sortingOrder3 === "asc" ? -1 : 1;
        if (aStr > bStr) return this.state.sortingOrder3 === "asc" ? 1 : -1;
        return 0;
      });
      sortedData = [...sortedUpcoming, ...otherData];
    }
    else if (value == 2) {
      const upcomingData = data.filter(item => item.status === "Upcoming");
      const otherData = data.filter(item => item.status !== "Upcoming");
      const sortedUpcoming = [...upcomingData].sort((a, b) => {
        const aValue = a[sortingField];
        const bValue = b[sortingField];
        if (!isNaN(aValue) && !isNaN(bValue)) {
          return this.state.sortingOrder1 === "asc"
            ? Number(aValue) - Number(bValue)
            : Number(bValue) - Number(aValue);
        }
        const aStr = aValue?.toString().toLowerCase() || '';
        const bStr = bValue?.toString().toLowerCase() || '';
  
        if (aStr < bStr) return this.state.sortingOrder1 === "asc" ? -1 : 1;
        if (aStr > bStr) return this.state.sortingOrder1 === "asc" ? 1 : -1;
        return 0;
      });
      sortedData = [...sortedUpcoming, ...otherData];
    }
    else if (value == 3){
      const upcomingData = data.filter(item => item.status === "Skipped" || item.status === "Completed");
      const otherData = data.filter(item => item.status !== "Skipped" && item.status !== "Completed");
  
      const sortedUpcoming = [...upcomingData].sort((a, b) => {
        const aValue = a[sortingField];
        const bValue = b[sortingField];

        if (!isNaN(aValue) && !isNaN(bValue)) {
          return this.state.sortingOrder2 === "asc"
            ? Number(aValue) - Number(bValue)
            : Number(bValue) - Number(aValue);
        }

        const aStr = aValue?.toString().toLowerCase() || '';
        const bStr = bValue?.toString().toLowerCase() || '';

        if (aStr < bStr) return this.state.sortingOrder2 === "asc" ? -1 : 1;
        if (aStr > bStr) return this.state.sortingOrder2 === "asc" ? 1 : -1;
        return 0;
      });
  
      sortedData = [...sortedUpcoming, ...otherData];
    }
    else{
     sortedData = [...data].sort((a, b) => {
      
      const aValue = a[sortingField]?.toString().toLowerCase();
      const bValue = b[sortingField]?.toString().toLowerCase();
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return this.state.sortingOrder === "asc"
          ? Number(aValue) - Number(bValue)
          : Number(bValue) - Number(aValue);
      }
      if (aValue < bValue) return this.state.sortingOrder === "asc" ? -1 : 1;
      if (aValue > bValue) return this.state.sortingOrder === "asc" ? 1 : -1;
      return 0;
    });
    }
    if (this.state.activeTab === "Active") {
      this.setState({ tableData: sortedData });
    } else if (this.state.activeTab === "Manage") {
      this.setState({ manageTableData: sortedData });
    }
  };

  sortImage = (order) => {
    if (!order)
      return (
        <span className="ascending">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.4712 8.47133L11.5286 7.52867L8.66656 10.3907V4H7.33323V10.3907L4.47123 7.52867L3.52856 8.47133L7.9999 12.9427L12.4712 8.47133Z"
              fill="#1D1E20"
            />
          </svg>
        </span>
      );
    else if (order === "asc")
      return (
        <span className="ascending">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.4712 8.47133L11.5286 7.52867L8.66656 10.3907V4H7.33323V10.3907L4.47123 7.52867L3.52856 8.47133L7.9999 12.9427L12.4712 8.47133Z"
              fill="#1D1E20"
            />
          </svg>
        </span>
      );
    else if (order === "desc")
      return (
        <span className="descending">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.4712 8.47133L11.5286 7.52867L8.66656 10.3907V4H7.33323V10.3907L4.47123 7.52867L3.52856 8.47133L7.9999 12.9427L12.4712 8.47133Z"
              fill="#1D1E20"
            />
          </svg>
        </span>
      );

    return null;
  };

  onActiveStatusChange = (val) => {
    const newStatus =
      this.state.activeStatus === "Active" ? "Inactive" : "Active";

    this.setState({ activeStatus: newStatus }, () => {
      this.getAllPreventativeMaintenance();
    });
  };

  rowClasses = (row: any, rowIndex: any) => {
    if (row.status === "Upcoming") {
      return "row-grayout";
    }
  };

  rowClassesActive = (row: any, rowIndex: any) => {
    if (row.status === "Overdue" && !row.hasStarted) {
      return "row-grayout";
    }
  };

  handleShowSlideout = (
    e: any,
    rowData: any,
    rowIndex: any,
    type: any,
    lastcycleId: any,
  ) => {
    if (type === "ParamcycleIdType") {
      let data = this.state.tableData;
      let row1 = data.filter((item) => item.cycleId === lastcycleId);
      if (row1.length > 0) {
        row1[0].seletedColor = "yes";
        this.setState({ tableData: data, showSlideout: false }, () => {
          this.setState({ lastcycleId: "", lastroomId: "", showSlideout: true, parentRowData: row1[0] });
        });
      }
    }
    if (rowData.hasStarted) {

      this.setState({ parentRowData: rowData }, () => {
        this.setState({
          showSlideout: true,
        });
      });
      // }
    }
  };

  handleHideSlideout = () => {
    this.setState({ showSlideout: false, searchText: '', 
    sortingOrder3: "asc",
    sortingField3: "name",
    sortingOrder1: "asc",
    sortingField1: "name",
    sortingOrder2: "asc",
    sortingField2: "name",
   }, () => {
      this.getAllPreventativeMaintenance();
    });
  };
  handleTabSelect = (selectedTab) => {
    this.setState({ activeTab: selectedTab }, () => {
      if (selectedTab == "Manage") {
        this.setState({
          sortingOrder: "asc",
          sortingField: "projectName" })
        this.getAllMaintenanceSchedule();
      }
      if (selectedTab == "Active") {
        this.setState({
        // sortingOrder3: "asc",
        // sortingField3: "name",
        sortingOrder1: "asc",
        sortingField1: "name",
        sortingOrder2: "asc",
        sortingField2: "name",
      })
        this.getAllPreventativeMaintenance();
      }
      if (this.manageTableSearchnew.current !== null)
      {
      this.manageTableSearchnew.current.CleanSearch();
      }
    });
    this.setState({searchText: "", sortingOrder3: "asc",
    sortingField3: "name",});
  }
  newPmProject = () => {
    this.setState({ isNewPmProject: true });
  }
  getAllMaintenanceSchedule = () => {
    const { searchText, status, frequency, priority, hidValue } = this.state;
    const request: IFacilityMaintenanceListRequest = {
      query: searchText,
      priority,
      status,
      frequency,
      hid: hidValue,
    };

    FacilityMaintenance.GetAllMaintenanceSchedule(request)
      .then((tableData: any[] | null) => {
        if ((tableData || [])?.length > 0) {
          tableData = (tableData || [])?.map((x) => {
            x.nextOccurrence = x?.nextOccurrence
              ? moment(x.nextOccurrence).format("MM/DD/YY")
              : "";

            if (x.priority?.toString()?.includes("High")) {
              x.priorityOrder = 1;
            } else if (x.priority?.toString()?.includes("Medium")) {
              x.priorityOrder = 2;
            } else if (x.priority?.toString()?.includes("Low")) {
              x.priorityOrder = 3;
            }

            if (x.frequency?.toString()?.includes("Day")) {
              x.frequencyOrder = 1;
            }
            if (x.frequency?.toString()?.includes("Days")) {
              x.frequencyOrder = 2;
            }
            if (x.frequency?.toString()?.includes("Month")) {
              x.frequencyOrder = 3;
            }
            if (x.frequency?.toString()?.includes("Months")) {
              x.frequencyOrder = 4;
            }
            if (x.frequency?.toString()?.includes("Year")) {
              x.frequencyOrder = 5;
            }
            if (x.frequency?.toString()?.includes("Year")) {
              x.frequencyOrder = 6;
            }
            return x;
          });
        }
        const sortedData = _.orderBy(
          tableData,
          [(x) => x.projectName?.toLowerCase()],
          ["asc"]
        );
        this.setState({ manageTableData: sortedData, 
          manageTableDataFilter: sortedData });
      })
      .catch((error) => {
        if ((error as any)?.message !== "Cancel") {
          Utils.toastError(error?.response?.data, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      });
  };
  CleanSearch = () => {
    if (this.manageTableSearchnew.current !== null)
      this.manageTableSearchnew.current.CleanSearch();
  };

  handleSearch = (searchQuery) => {
    this.handleSelectedItem.call(this, 1, searchQuery)
  };
  handleSelectedItem = (controlID: any, searchQuery: any) => {
    if (controlID === 1) {
      this.setState({
        searchQuery: searchQuery,
        sortingOrder: "asc",sortingField: "projectName"
        // isSlideOut: false,
      });
      this.FilterList(
        searchQuery
      );
    }
  };
  FilterList(
    searchQuery: string = ''
  ) {
    let filterListDate: any[] = [];
    filterListDate = _.cloneDeep(this.state.manageTableDataFilter);
    if (searchQuery !== '') {
      filterListDate = filterListDate.filter((item) => item.projectName.toLowerCase().includes(searchQuery.toLowerCase()));
      this.setState({
        manageTableData: filterListDate
      });
    }
    else {
      this.setState({
        manageTableData: this.state.manageTableDataFilter
      });
    }

  }
  isRequestSave = (item: any) => {
  
    let Data: any = [];
    Data.push(item);

    this.setState({ isSlideOut: false, manageParentRowData: Data }, () => {
      this.setState({ isSlideOut: true });
    });
  }

  closeWorkSlideOut = () => {
    this.setState({ isSlideOut: false,
    },()=>{
      if (this.manageTableSearchnew?.current?.input?.current?.value !== '') 
      {
        this.manageTableSearchnew.current.CleanSearch();
        }
      // this.getAllMaintenanceSchedule();
    });
  }
  saveCloseWorkSlideOut = () => {
    this.setState({ isSlideOut: false,sortingOrder: "asc",sortingField: "projectName"}, () => {
      if (this.manageTableSearchnew.current !== null)
        {
        this.manageTableSearchnew.current.CleanSearch();
        }
      this.getAllMaintenanceSchedule();
    });
  }
  onRowClick = (
      e: any,
      row: any,
      rowIndex: any,
      type: any,
      lastworkOrderID: any
    ) => {
      let frequency_value = "t";
      let maintenceData: any = {};
      maintenceData.id = row.id;
      maintenceData.name = row.projectName;
      maintenceData.description = row.description;
      maintenceData.startDate = moment(row.startDate).format("MM/DD/YYYY");
      maintenceData.endDate = row.endDate == null ? "" : moment(row.endDate).format("MM/DD/YYYY");
      maintenceData.frequenId = row.frequencyValue;
      maintenceData.frequency = row.frequency;
      maintenceData.frequencyCustom = row.frequencyCustom;
      maintenceData.frequencyOrginalValue = row.frequencyOrginalValue;
      maintenceData.assignedTo = row.assignedTo;
      maintenceData.nextOccurrence = row.nextOccurrence;
      maintenceData.status=row.status;
      frequency_value = row.frequencyOrginalValue;
      maintenceData.isChanges=false;
      maintenceData.isNew = false;
      let Data: any = [];
      Data.push(maintenceData);
      this.setState({ isSlideOut: false, manageParentRowData: Data }, () => {
        this.setState({ isSlideOut: true });
      });
    }
  iscloseModulePopup = () => {
    if (this.manageTableSearchnew?.current?.input?.current?.value !== '') 
    {
      this.manageTableSearchnew?.current?.CleanSearch();
    }
    this.setState({ isNewPmProject: false});
    // this.getAllMaintenanceSchedule();
  }
  isSavecloseModulePopup = () => {
    if (this.manageTableSearchnew.current !== null)
    {
      this.manageTableSearchnew?.current?.CleanSearch();
    }
    this.setState({ isNewPmProject: false,sortingOrder: "asc",sortingField: "projectName"});
    this.getAllMaintenanceSchedule();
  }
  reasonChange = (e: any) => {
    let value = e.target.value?.toString()?.trimLeft();
    this.setState({ reason: value }, () => {      
    });
  };
  reasonOnBular = () => {    
    if(this.state.reason!==""){
      this.setState({ errors: false });
    }else{
      this.setState({reason:this.state.reason?.trimRight()});
    }
    
  };
  handleBulkImport = () => {
    this.setState({
      bulkImportModal: true,
    });
  }
  bulkHideModule = () => {
    this.setState({ bulkImportModal: false });
  }
  saveBulkHideModule = () => {
    this.setState({ bulkImportModal: false });
    this.getAllMaintenanceSchedule();
  }
  render() {
    const {
      frequencies,
      priorities,
      searchText,
      status,
      frequency,
      activeStatus,
      isDataLoading,
      priority,
      createEditPermission,
      selectedRows,
      manageTableData
    } = this.state;

    const tableColumnEvent = {
      onClick: (e, column, columnIndex, row, rowIndex) => {
        //debugger;
        // if (this.state.isPMCycleType == "ParamcycleIdType") {
        //   this.handleShowSlideout("", "row", "", "ParamcycleIdType", Number(this.state.lastcycleId));
        // }
        // else{
        this.handleShowSlideout("", row, "", "", "");
        // }
      },
    };
    const manageTableColumnEvent = {
      onClick: (e, column, columnIndex, row, rowIndex) => {
          this.onRowClick(e, row, rowIndex, "table", "");
      },
    };

    const columns = [
      {
        dataField: "name",
        text: "Name",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField3 === "name" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnActive("name")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder3)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <div className="maintenance-name">
                <EllipsisWithTooltip placement="bottom">
                  {row.name}
                </EllipsisWithTooltip>
                {row.maintenanceStatus == "Inactive" && (
                  <span className="badge color-grey-beta">
                    {row.maintenanceStatus}
                  </span>
                )}
              </div>
            </>
          );
        },
      },
      {
        dataField: "status",
        text: "Status",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField3 === "status" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnActive("status")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder3)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div
                  className={`badge active ${row.status.toLowerCase() == "in progress"
                      ? "progress"
                      : row.status.toLowerCase() == "overdue"
                        ? "overdue"
                        : row.status.toLowerCase() == "complete" || row.status.toLowerCase() == "completed"
                          ? "completed"
                          : row.status.toLowerCase() == "on hold"
                            ? "hold"
                            : row.status.toLowerCase() == "skipped"
                            ? "skipped"
                            : ""
                    }`}
                >
                  {row.status}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "noOfLocations",
        text: "Locations",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField3 === "noOfLocations" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnActive("noOfLocations")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder3)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              {row.noOfLocations == 0 ? (
                <></>
              ) : (
                <EllipsisWithTooltip placement="bottom">
                  <div className="">{row.noOfLocations} </div>{" "}
                </EllipsisWithTooltip>
              )}
            </>
          );
        },
      },

      {
        dataField: "startDate",
        text: "Start Date",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField3 === "startDate" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnActive("startDate")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder3)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">
                  {moment(row.startDate).format("MM/DD/YY")}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "dueDate",
        text: "Due Date",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField3 === "dueDate" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnActive("dueDate")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder3)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">
                  {moment(row.dueDate).format("MM/DD/YY")}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "progress",
        text: "Progress",
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField3 === "progress" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnActive("progress")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder3)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <div className="d-flex align-items-center loader-wrap">
                <div style={{ minWidth: "50px" }}>{`${row?.progress}%`}</div>
                <div className="ml-3" style={{ width: 20, height: 20, transform: "scale(1.2)" }}>
                  <CircularProgressbar
                    value={row?.progress}
                    strokeWidth={12}
                    styles={buildStyles({
                      textColor: "#000",
                      pathColor: "#1ACAA3",
                      trailColor: "#E0E3E6",
                      strokeLinecap: "round",
                      pathTransitionDuration: 0.5
                    })}
                  />
                </div>
                {/* <Dropdown className="more-action ml-auto position-static">
                  <DropdownToggle
                    className={`btn-outline-primary btn btn-primary more ${row.status === "In Progress" || row.status === 'Completed' ? "disabled" : ""
                      }`}
                    id="dropdown-more"
                    disabled={
                      row.canStart !== 1 ||
                      !this.state?.createEditPermission || row.status === "In Progress" || row.status === 'Completed'
                    }
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={() => this.startEarly(row.cycleId,moment(row.startDate).format("MM/DD/YY"))}>
                      Start Early
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown> */}
              </div>
            </>
          );
        },
      },
    ];
    const columns1 = [
      {
        dataField: "name",
        text: "Name",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField1 === "name" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnUpcoming("name")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder1)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <div className="maintenance-name">
                <EllipsisWithTooltip placement="bottom">
                  {row.name}
                </EllipsisWithTooltip>
                {row.maintenanceStatus == "Inactive" && (
                  <span className="badge color-grey-beta">
                    {row.maintenanceStatus}
                  </span>
                )}
              </div>
            </>
          );
        },
      },
      {
        dataField: "status",
        text: "Status",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField1 === "status" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnUpcoming("status")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder1)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div
                  className={`badge active ${row.status.toLowerCase() == "in progress"
                      ? "progress"
                      : row.status.toLowerCase() == "overdue"
                        ? "overdue"
                        : row.status.toLowerCase() == "complete" || row.status.toLowerCase() == "completed"
                          ? "completed"
                          : row.status.toLowerCase() == "on hold"
                            ? "hold"
                            : row.status.toLowerCase() == "skipped"
                            ? "skipped"
                            : ""
                    }`}
                >
                  {row.status}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "noOfLocations",
        text: "Locations",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField1 === "noOfLocations" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnUpcoming("noOfLocations")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder1)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              {row.noOfLocations == 0 ? (
                <></>
              ) : (
                <EllipsisWithTooltip placement="bottom">
                  <div className="">{row.noOfLocations} </div>{" "}
                </EllipsisWithTooltip>
              )}
            </>
          );
        },
      },

      {
        dataField: "startDate",
        text: "Start Date",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField1 === "startDate" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnUpcoming("startDate")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder1)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">
                  {moment(row.startDate).format("MM/DD/YY")}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "dueDate",
        text: "Due Date",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField1 === "dueDate" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnUpcoming("dueDate")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder1)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">
                  {moment(row.dueDate).format("MM/DD/YY")}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "progress",
        text: "Progress",
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField1 === "progress" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnUpcoming("progress")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder1)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          const isAlreadyInProgress = this.state.tableData.some(
            item =>
              item.maintenanceScheduleId === row.maintenanceScheduleId &&
              (item.status === "In Progress" || 
              item.status === "Overdue")
          );
          const tooltip = (
            // <Tooltip id={`tooltip-${rowIndex}`}>
            //   {isAlreadyInProgress
            //     ? "Please complete previous Preventative Maintenance daily project before starting work on this PM project."
            //     : " "}
            // </Tooltip>
            <Tooltip id={`tooltip-${rowIndex}`}
            style={{ display: isAlreadyInProgress ? 'block' : 'none' }} 
            >
              Please complete previous Preventative Maintenance daily project before starting work on this PM project.
          </Tooltip>
          );
          return (
            <>
              <div className="d-flex align-items-center loader-wrap">
                <div style={{ minWidth: "50px" }}>{`${row?.progress}%`}</div>
                <div className="ml-3" style={{ width: 20, height: 20, transform: "scale(1.2)" }}>
                  <CircularProgressbar
                    value={row?.progress}
                    strokeWidth={12}
                    styles={buildStyles({
                      textColor: "#000",
                      pathColor: "#1ACAA3",
                      trailColor: "#E0E3E6",
                      strokeLinecap: "round",
                      pathTransitionDuration: 0.5
                    })}
                  />
                </div>
                <OverlayTrigger placement="bottom" overlay={tooltip}>
                  
                <Dropdown className="more-action ml-auto position-static">
                  <DropdownToggle
                    className={`btn-outline-primary btn btn-primary more  ${(row.status === "In Progress" || row.status == "Overdue") ? "disabled" : ""
                      }`}
                    id="dropdown-more"
                    disabled={
                      row.canStart !== 1 ||
                      !this.state?.createEditPermission || row.status === "In Progress" ||  row.status == "Overdue" || isAlreadyInProgress
                    }
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={() => this.startEarly(row.cycleId,moment(row.startDate).format("MM/DD/YY"))}>
                      Start Early
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown> 
                </OverlayTrigger>
              </div>
            </>
          );
        },
      },
    ];
    const columns2 = [
      {
        dataField: "name",
        text: "Name",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField2 === "name" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnHistory("name")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder2)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <div className="maintenance-name">
                <EllipsisWithTooltip placement="bottom">
                  {row.name}
                </EllipsisWithTooltip>
                {row.maintenanceStatus == "Inactive" && (
                  <span className="badge color-grey-beta">
                    {row.maintenanceStatus}
                  </span>
                )}
              </div>
            </>
          );
        },
      },
      {
        dataField: "status",
        text: "Status",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField2 === "status" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnHistory("status")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder2)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div
                  className={`badge active ${row.status.toLowerCase() == "in progress"
                      ? "progress"
                      : row.status.toLowerCase() == "overdue"
                        ? "overdue"
                        : row.status.toLowerCase() == "complete" || row.status.toLowerCase() == "completed"
                          ? "completed"
                          : row.status.toLowerCase() == "on hold"
                            ? "hold"
                            : row.status.toLowerCase() == "skipped"
                            ? "skipped"
                            : ""
                    }`}
                >
                  {row.status}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "noOfLocations",
        text: "Locations",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField2 === "noOfLocations" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnHistory("noOfLocations")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder2)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              {row.noOfLocations == 0 ? (
                <></>
              ) : (
                <EllipsisWithTooltip placement="bottom">
                  <div className="">{row.noOfLocations} </div>{" "}
                </EllipsisWithTooltip>
              )}
            </>
          );
        },
      },

      {
        dataField: "startDate",
        text: "Start Date",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField2 === "startDate" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnHistory("startDate")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder2)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">
                  {moment(row.startDate).format("MM/DD/YY")}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "dueDate",
        text: "Completed Date",
        events: tableColumnEvent,
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField2 === "dueDate" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnHistory("dueDate")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder2)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">
                  {moment(row.dueDate).format("MM/DD/YY")}{" "}
                </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "progress",
        text: "Progress",
        headerFormatter: (column) => {
          return (
            <div
              className={`d-inline-block ${this.state.sortingField2 === "progress" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumnHistory("progress")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder2)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <div className="d-flex align-items-center loader-wrap">
                <div style={{ minWidth: "50px" }}>{`${row?.progress}%`}</div>
                <div className="ml-3" style={{ width: 20, height: 20, transform: "scale(1.2)" }}>
                  <CircularProgressbar
                    value={row?.progress}
                    strokeWidth={12}
                    styles={buildStyles({
                      textColor: "#000",
                      pathColor: "#1ACAA3",
                      trailColor: "#E0E3E6",
                      strokeLinecap: "round",
                      pathTransitionDuration: 0.5
                    })}
                  />
                </div>
                {/* <Dropdown className="more-action ml-auto position-static">
                  <DropdownToggle
                    className={`btn-outline-primary btn btn-primary more ${row.status === "In Progress" ? "disabled" : ""
                      }`}
                    id="dropdown-more"
                    disabled={
                      row.canStart !== 1 ||
                      !this.state?.createEditPermission || row.status === "In Progress"
                    }
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={() => this.startEarly(row.cycleId,moment(row.startDate).format("MM/DD/YY"))}>
                      Start Early
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown> */}
              </div>
            </>
          );
        },
      },
    ];
    const manageColumns = [
      {
        dataField: "projectName",
        text: "Name",
        events: manageTableColumnEvent,
        headerFormatter: (column) => {

          return (
            <div
              className={`d-inline-block ${this.state.sortingField === "projectName" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumn("projectName")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                {row.projectName}
              </EllipsisWithTooltip>
            </>
          );
        },
      },
      {
        dataField: "noOfLocations",
        text: "Locations",
        events: manageTableColumnEvent,
        headerFormatter: (column) => {

          return (
            <div
              className={`d-inline-block ${this.state.sortingField === "noOfLocations" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumn("noOfLocations")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">{row.noOfLocations} </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },
      {
        dataField: "frequency",
        text: "Frequency",
        events: manageTableColumnEvent,
        headerFormatter: (column) => {
          console.log(column);
          return (
            <div
              className={`d-inline-block ${this.state.sortingField === "frequency" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumn("frequency")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">{row.frequency} </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },

      {
        dataField: "nextOccurrence",
        text: "Next Start",
        events: manageTableColumnEvent,
        headerFormatter: (column) => {

          return (
            <div
              className={`d-inline-block ${this.state.sortingField === "nextOccurrence" ? "active" : ""
                }`}
              onClick={() => this.handleSortByColumn("nextOccurrence")}
            >
              {column.text}
              {this.sortImage(this.state.sortingOrder)}
            </div>
          );
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <div className="">{row.nextOccurrence} </div>{" "}
              </EllipsisWithTooltip>
            </>
          );
        },
      },
    ];

    const tableRowEvents = {
      onClick: (e, row, rowIndex) => {
        // this.handleShowSlideout(row);
      },
    };

    return (
      <>
        <div className="performance-position performance timesheet location-page-wrapper preventative-maintenance-page">
          <Container fluid className="body-sec">
            <div className="page-heading d-flex">
              <HidSelector
                onClickEvent={this.selectHotelDropDown}
                ref={this.childHID}
                modulename={"Facility Maintenance"}
              />
              <div className="mr-auto d-flex align-items-center">
                Preventative Maintenance
              </div>
              {this.state.hidValue !== "Select" &&
                this.state.activeTab == "Manage" &&
                // this.state?.createEditPermission &&
                <Button onClick={() => this.newPmProject()} disabled={selectedRows?.length > 0} >New Preventative Maintenance</Button>
              }
              {this.state.hidValue !== "Select" &&
              this.state.activeTab == "Manage" && (
              <Dropdown className="more-action ml-3">
                <DropdownToggle
                  disabled={!createEditPermission}
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </DropdownToggle>
                <Dropdown.Menu className="import-location-btn" onClick={this.handleBulkImport}>Bulk Upload
                                   </Dropdown.Menu>
              </Dropdown>
              )}
            </div>
            {/* {this.state.pageLoader ? (
              <ReactPageLoader useas={"timesheetMain"} />
            ) : ( */}
            {this.state.hidValue === "Select" &&
              (<div className="facilities-landing-empty-page d-flex align-items-center justify-content-center flex-direction-column">
                <div className="font-weight-bold text-dark">
                  No EHID selected
                </div>
                <div className="FrameText">
                  Use the <span>EHID</span> selector to begin.
                </div>
              </div>
              )}
            {this.state.hidValue !== "Select" && (
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="Details"
                activeKey={this.state.activeTab}
                onSelect={this.handleTabSelect}
              >
                <div>
                  <Nav className="nav-tabs flex-row">
                    <Nav.Item className="align-content-end">
                      <Nav.Link eventKey="Active" className="d-flex"><span> Active </span>
                      </Nav.Link>
                    </Nav.Item>
                    {this.state.manageCreateEditPermission && (
                      <Nav.Item className="align-content-end">
                        <Nav.Link eventKey="Manage"><span> Manage </span>
                        </Nav.Link>
                      </Nav.Item>
                    )}
                  </Nav>
                </div>
                <div>
                  <Tab.Content>
                    <Tab.Pane eventKey="Active">
                      {(!this.state.initialTableData || this.state.initialTableData.length === 0) ? (
                        <div className="Manage-empty-data facilities-landing-empty-page d-flex align-items-center justify-content-center flex-direction-column">
                          <div className="font-weight-bold text-dark">
                            No Active Schedules
                          </div>
                          {this.state.manageCreateEditPermission && (
                            <div className="font-weight-bold ManageFrameText">
                              Create a schedule in the{" "}
                              <span
                                onClick={() => this.handleTabSelect("Manage")}
                              >
                                Manage
                              </span>{" "}
                              tab above
                            </div>
                          )}
                          <div className="empty-data-icon">
                            <img src={blankImg} alt="empty-data" />
                          </div>
                        </div>
                      ) : (<div className="main-Page accordion-style">
                        <div className="departmentViewNavigation">
                          <div className="navigation-menus d-flex">
                            <div className="schedule-table-search">
                              <input
                                type="text"
                                onChange={(e) =>
                                  this.onSearchChange(e.target.value)
                                }
                                value={searchText}
                                className="search-box form-control"
                                placeholder="Search..."
                              />
                            </div>
                          </div>
                        </div>
                        {this.state?.tableData?.filter(row => row?.status !== "Skipped" && row?.status !== "Upcoming" && row?.status !== "Completed").length > 0 && (
                        <Accordion activeKey={this.state.activeKeys}>
                          <Card>
                            <Card.Header>
                              <Accordion.Toggle
                                as={Button} className={this.state.activeKeys.includes("0") ? 'activeToggle' : ''}
                                onClick={() => this.handleAccordionToggle("0")} variant="link" eventKey="0">
                                <div className="d-flex align-items-center">
                                  <div>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.29297 10.707L12 16.414L17.707 10.707L16.293 9.293L12 13.586L7.70697 9.293L6.29297 10.707Z" fill="#84888C" />
                                    </svg>
                                  </div>
                                  <div className="mr-auto accodian-title">Active</div>
                                </div>
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0" className={this.state.activeKeys.includes("0") ? "show" : ""}>
                              <Card.Body>
                                {/* Active schedule content here... */}
                                <div className="bdy-sec">
                                  <ToolkitProvider
                                    keyField="userUniqueno"
                                    // data={this.state.tableData}
                                    columns={columns}
                                    hover
                                  >
                                    {(props: {
                                      searchProps: JSX.IntrinsicAttributes;
                                      baseProps: JSX.IntrinsicAttributes;
                                    }) => (
                                      <div>
                                        {/* <div className="search-header d-flex">
                                          <div className="room-type-dropdown">
                                            {statusList?.length > 0 && (
                                              <SingleSearchDropdownList
                                                id={"ddlStatus"}
                                                isRefresh={this.state.isRefresh}
                                                itemList={statusList}
                                                handleSelectedItem={this.onDDlFiltersChange.bind(
                                                  this,
                                                  "ddlStatus"
                                                )}
                                                defaultItem={status}
                                                defaultText={"Search Status"}
                                                defaultName={status == "" ? "Assigned To" : status}
                                                controlID="2"
                                              />
                                            )}
                                          </div>
                                        </div> */}

                                        <div className="hasCursorPointer position-relative hide-header-scrollbar">
                                          <div className="block-bar"></div>
                                          <BootstrapTable
                                            id={"preventative-maintenance-tbl"}
                                            {...props.baseProps}
                                            keyField="cycleId"
                                            rowClasses={this.rowClassesActive}
                                            hover
                                            // data={this.state.tableData}
                                            data={this.state?.tableData?.filter(row => row?.status !== "Skipped" && row?.status !== "Upcoming" && row?.status !== "Completed")}
                                          // rowEvents={tableRowEvents}
                                          />
                                          {/* {this.state.tableData.length == 0 &&
                                            (
                                              <div className="WorkOrderNoDataFrame d-flex align-items-center justify-content-center flex-direction-column">
                                                <div>
                                                  No results matching your filters.
                                                </div>
                                              </div>
                                            )} */}
                                        </div>
                                      </div>
                                    )}
                                  </ToolkitProvider>
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                        )}
                        {this.state?.tableData?.filter(row => row?.status === "Upcoming").length > 0 && (
                        <Accordion activeKey={this.state.activeKeys}>
                          <Card>
                            <Card.Header>
                              <Accordion.Toggle
                                as={Button} className={this.state.activeKeys.includes("1") ? 'activeToggle' : ''}
                                onClick={() => this.handleAccordionToggle("1")} variant="link" eventKey="1">
                                <div className="d-flex align-items-center">
                                  <div>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.29297 10.707L12 16.414L17.707 10.707L16.293 9.293L12 13.586L7.70697 9.293L6.29297 10.707Z" fill="#84888C" />
                                    </svg>
                                  </div>
                                  <div className="mr-auto accodian-title">Upcoming (90 Days)</div>
                                </div>
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="1" className={this.state.activeKeys.includes("1") ? "show" : ""}>
                              <Card.Body>
                                <div className="bdy-sec">
                                <div className="bdy-sec">
                                  <ToolkitProvider
                                    keyField="userUniqueno"
                                    // data={this.state.tableData}
                                    columns={columns1}
                                    hover
                                  >
                                    {(props: {
                                      searchProps: JSX.IntrinsicAttributes;
                                      baseProps: JSX.IntrinsicAttributes;
                                    }) => (
                                      <div>
                                        <div className="hasCursorPointer position-relative hide-header-scrollbar">
                                          <div className="block-bar"></div>
                                          <BootstrapTable
                                            id={"preventative-maintenance-tbl"}
                                            {...props.baseProps}
                                            keyField="cycleId"
                                            rowClasses={this.rowClasses}
                                            hover
                                            // data={this.state.tableData}
                                            data={this.state?.tableData?.filter(row => row?.status === "Upcoming")}
                                          // rowEvents={tableRowEvents}
                                          />
                                          {/* {this.state.tableData.length == 0 &&
                                            (
                                              <div className="WorkOrderNoDataFrame d-flex align-items-center justify-content-center flex-direction-column">
                                                <div>
                                                  No results matching your filters.
                                                </div>
                                              </div>
                                            )} */}
                                        </div>
                                      </div>
                                    )}
                                  </ToolkitProvider>
                                </div>
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                        )}
                        {this.state?.tableData?.filter(row => row?.status === "Skipped" || row?.status === "Completed").length > 0 && (
                        <Accordion activeKey={this.state.activeKeys}>
                          <Card>
                            <Card.Header>
                              {/* {this.state?.tableData?.filter(row => row?.status === "Skipped" || row?.status === "Completed").length > 0 && ( */}
                              <Accordion.Toggle
                                as={Button} className={this.state.activeKeys.includes("2") ? 'activeToggle' : ''}
                                onClick={() => this.handleAccordionToggle("2")} variant="link" eventKey="2">
                                <div className="d-flex align-items-center">
                                  <div>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.29297 10.707L12 16.414L17.707 10.707L16.293 9.293L12 13.586L7.70697 9.293L6.29297 10.707Z" fill="#84888C" />
                                    </svg>
                                  </div>
                                  <div className="mr-auto accodian-title">History</div>
                                </div>
                              </Accordion.Toggle>
                              {/* )} */}
                            </Card.Header>
                            <Accordion.Collapse eventKey="2" className={this.state.activeKeys.includes("2") ? "show" : ""}>
                              <Card.Body>
                              <div className="bdy-sec">
                                  <ToolkitProvider
                                    keyField="userUniqueno"
                                    // data={this.state.tableData}
                                    columns={columns2}
                                    hover
                                  >
                                    {(props: {
                                      searchProps: JSX.IntrinsicAttributes;
                                      baseProps: JSX.IntrinsicAttributes;
                                    }) => (
                                      <div>
                                        <div className="hasCursorPointer position-relative hide-header-scrollbar">
                                          <div className="block-bar"></div>
                                          <BootstrapTable
                                            id={"preventative-maintenance-tbl"}
                                            {...props.baseProps}
                                            keyField="cycleId"
                                            rowClasses={this.rowClasses}
                                            hover
                                            // data={this.state.tableData}
                                            data={this.state?.tableData?.filter(row => row?.status === "Skipped" || row?.status === "Completed")}
                                          // rowEvents={tableRowEvents}
                                          />
                                          {/* {this.state?.tableData?.filter(row => row?.status === "Skipped" || row?.status === "Completed").length == 0 &&
                                            (
                                              <div className="WorkOrderNoDataFrame d-flex align-items-center justify-content-center flex-direction-column">
                                                <div>
                                                  No results matching your filters.
                                                </div>
                                              </div>
                                            )} */}
                                        </div>
                                      </div>
                                    )}
                                  </ToolkitProvider>
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                        )}
                          <>
                            {this.state?.tableData?.length == 0 &&
                              (
                                <div className="Manage-empty-data facilities-landing-empty-page d-flex align-items-center justify-content-center flex-direction-column">
                                  <div className="font-weight-bold text-dark">
                                    No results matching your filters.
                                  </div>
                                </div>
                              )}
                          </>
                      </div>
                      )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="Manage">
                    {this.state.bulkImportModal && (
                    <MaintenanceScheduleBulkUpload
                      bulkImportModal={this.handleBulkImport}
                      bulkHideModule={this.bulkHideModule}
                      saveBulkHideModule={this.saveBulkHideModule}
                      hotelId={this.state.hidValue}
                      assetTypes={this.state.assetTypes}
                      allMaintenanceSchedule={this.state.manageTableDataFilter}
                    // isBulkInvoiceModal={this.state.isBulkInvoiceSlideout}
                    // bulkHideModule={this.bulkHideModule()} 
                    />
                    )}
                      {(!this.state.manageTableDataFilter || this.state.manageTableDataFilter.length === 0) ? (
                        <div className="Manage-empty-data facilities-landing-empty-page d-flex align-items-center justify-content-center flex-direction-column">
                          <div className="font-weight-bold text-dark">
                            There are no schedules to display
                          </div>
                          <div className="font-weight-bold ManageFrameText">
                            Click the <span onClick={() => this.newPmProject()}>New Preventative Maintenance</span> button to get started.
                          </div>
                          <div className="empty-data-icon">
                            <img src={blankImg} alt="empty-data" />
                          </div>
                        </div>
                      ) : (<div className="main-Page">
                        <div className="bdy-sec">
                          <ToolkitProvider
                            keyField="userUniqueno"
                            data={manageTableData}
                            columns={manageColumns}
                            hover
                          >
                            {(props: {
                              searchProps: JSX.IntrinsicAttributes;
                              baseProps: JSX.IntrinsicAttributes;
                            }) => (
                              <div>
                                <div className="search-header d-flex">
                                  <div className="schedule-main">
                                    <div className="schedule-department-view-table">
                                      <div className="departmentViewNavigation">
                                        <div className="navigation-menus d-flex">
                                          <div className="schedule-table-search">
                                            <TableSearch
                                              id="tableSearch"
                                              key="tableSearch"
                                              ref={this.manageTableSearchnew}
                                              {...props.searchProps}
                                              CleanSearch={this.CleanSearch.bind(this)}
                                              placeholder={"Search..."}
                                              onSearch={(searchQuery) => this.handleSearch(searchQuery)}
                                            />
                                            {/* <input
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onSearchChange(e.target.value)
                                                    }
                                                    value={searchText}
                                                    disabled={selectedRows?.length > 0}
                                                    className="search-box form-control"
                                                    placeholder="Search..."
                                                  /> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`hasCursorPointer position-relative hide-header-scrollbar ${selectedRows?.length > 0 ? "bottom-space" : ""
                                    }`}
                                >
                                  <div className="block-bar"></div>
                                  <BootstrapTable
                                    id={"maitenanceScheduleTable"}
                                    {...props.baseProps}
                                    keyField="id"
                                    hover
                                  // rowEvents={tableRowEvents}
                                  />
                                  {this.state.manageTableData.length == 0 &&
                                    (
                                      <div className="WorkOrderNoDataFrame d-flex align-items-center justify-content-center flex-direction-column">
                                        <div>
                                          No results matching your filters.
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            )}
                          </ToolkitProvider>


                          {this.state.isSlideOut && (
                            <div>
                              <MaintenanceSchudleSlieOut
                                      //  ref={this.wororderSlideOut}
                                      closeWorkSlideOut={this.closeWorkSlideOut}
                                      parentState={this.state}
                                      assetTypes={this.state.assetTypes}
                                      saveCloseWorkSlideOut={this.saveCloseWorkSlideOut}
                                      // parentRowData={this.state.manageParentRowData}
                                    //workOrderStatusUpdate={this.workOrderStatusUpdate}
                                    //changesOfSlideOut={this.changesOfSlideOut}
                                    //refeshTable={this.refeshTable}                               
                                    />
                            </div>

                          )}


                        </div>
                      </div>
                      )}
                    </Tab.Pane>
                  </Tab.Content>
                </div>

              </Tab.Container>
            )}
            {this.state.showSlideout && (
              <PreventativeMaintenanceSlideOut
                parentRowData={this.state.parentRowData}
                parentState={this.state}
                handleHideSlideout={this.handleHideSlideout}
                createEditPermission={createEditPermission}
              />
            )}
          </Container>
        </div>
        {this.state.isNewPmProject && (
          <AddMaintenanceSchedule
            hid={this.state.hidValue}
            // priorityList={this.state.priorityList}
            showAddNewPmProject={this.state.isNewPmProject}
            // isRequestSave={this.isRequestSave}
            // assignToList={this.state.assignToListToChild}
            iscloseModulePopup={this.iscloseModulePopup}
            isSavecloseModulePopup={this.isSavecloseModulePopup}
            allMaintenanceSchedule={this.state.manageTableDataFilter}
            assetTypes={this.state.assetTypes}
          // locationTypesList={this.state.locationTypesList}

          />
        )}

        {this.state.isStartEarly && (
          <Modal
            show={this.state.isStartEarly}
            onHide={this.handleOnCancel}
            centered
            className="add-edit-time-off-shift-modal AddTimeOffRequestModal schedule-modal schedule-instance-early-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>
              Start Schedule Instance Early
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="alert-danger rounded p-3 mb-4">This schedule isn't scheduled to start until {this.state.rowstartDate}. Are you sure you want to start it now?</div>
              <Form>
                <Form.Label>Reason for early start <span className="text-danger">*</span></Form.Label>
                <span className={this.state.errors ? " alert-danger" : ""}>
                <Form.Control placeholder="Please explain why you need to start this schedule early..." as="textarea" 
                rows={3}
                maxLength={300}
                onChange={(e) => this.reasonChange(e)}
                onBlur={() => this.reasonOnBular()}
                 />
                 </span>
              </Form>
              
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex">
                <Button
                  type="button"
                  onClick={this.handleOnCancel}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  onClick={this.handleStartEarly}
                >
                  Start Early
                </Button>
              </div>
            </Modal.Footer>
          </Modal>



        )}


      </>
    );
  }
}
